<template>
  <v-card
    flat
    class="radius-10"
    color="grey lighten-4"
  >
    <file-upload
      ref="upload"
      v-model="files"
      :post-action="postAction"
      :accept="acceptedFileTypes"
      :multiple="true"
      :thread="3"
      :headers="headers"
      :data="postData"
      :drop="true"
      :drop-directory="false"
      :input-id="category"
      @input-filter="inputFilter"
      @input-file="inputFile"
    >
      <div
        class="text-center grey--text py-4"
      >
        click to upload
      </div>
    </file-upload>
    <div
      v-if="files.length"
      class="pa-2"
    >
      <div v-if="entityType === entityTypeYachtModel">
        <file-card
          v-for="file in files"
          :key="file.id"
          :file="file"
          :can-remove="canRemove"
          :can-edit="canEdit"
        />
      </div>
      <div v-else>
        <simple-file-card
          v-for="file in files"
          :key="file.id"
          :file="file"
          :can-remove="canRemove"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
  import axios from '@/plugins/axios'
  import FileUpload from 'vue-upload-component'
  import File from '@/models/File'
  import FileCard from './FileCard'
  import SimpleFileCard from './SimpleFileCard'

  export default {
    name: 'Dropzone',
    components: {
      FileCard,
      SimpleFileCard,
      FileUpload
    },
    inheritAttrs: false,
    props: {
      initialFiles: {
        type: Array,
        default: null
      },
      entityType: {
        type: String,
        default: null
      },
      dropzoneId: {
        type: String,
        default: 'dz'
      },
      category: {
        type: String,
        default: File.CATEGORY_DOCUMENT,
        validator: function (value) {
          // The value must match one of these strings
          return [File.CATEGORY_DOCUMENT, File.CATEGORY_PHOTO].indexOf(value) > -1
        }
      },
      acceptedFileTypes: {
        type: String,
        default: undefined
      },
      canUpload: {
        type: Boolean,
        default: true
      },
      canRemove: {
        type: Boolean,
        default: true
      },
      canEdit: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        // files: [],
        postAction: axios.defaults.baseURL + '/files',
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.token
        },
        postData: {
          category: this.category,
          main: false,
          entity_type: this.entityType
        }
      }
    },
    computed: {
      files: {
        get: function () {
          return this.$store.state.dropzone.files.filter(f => f.dropzoneId === this.dropzoneId)
        },
        set: function (files) {
          this.$store.dispatch('updateFiles', { files: files, dropzoneId: this.dropzoneId })
        }
      },
      entityTypeYachtModel() {
        return File.TYPE_YACHT_MODEL
      },
      entityTypeServiceTask() {
        return File.TYPE_SERVICE_TASK
      }
    },
    watch: {
      initialFiles() {
        this.initStoreStorage()
      }
    },
    created () {
      this.initStoreStorage()
    },
    methods: {
      removeFile(fileId) {
        // this.files.splice(this.files.findIndex(f => f.id === fileId), 1)
        // this.$store.dispatch('removeFile', fileId)
      },
      inputFilter(newFile, oldFile, prevent) {
        // Create a blob field
        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // blob
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
          // Thumbnails
          newFile.thumb = ''
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob
          }
        }
      },
      inputFile(newFile, oldFile) {
        // Automatically activate upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            this.$refs.upload.active = true
          }
        }
      },
      initStoreStorage () {
        this.$store.dispatch('addFiles', { files: this.initialFiles, dropzoneId: this.dropzoneId })
      }
    }
  }
</script>
<style scoped>
  .file-uploads {
    width: 100%;
  }
</style>
